import * as React from 'react';
import { useStyles, useCountDown } from '@sravni/react-utils';
import modules_037eb246 from '../styles/CountDown.module.less.js';

/**
 * @description CountDown component.
 *
 * @component
 * @example
 * ```jsx
 * <CountDown from={0} to={987654} />
 * ```
 */
const CountDown = React.forwardRef((props, ref) => {
    const { from, to, speed, interval, formatter, className, ...restProps } = props;
    const cx = useStyles(modules_037eb246);
    const value = useCountDown({ from, to, speed, interval, formatter });
    const classNames = cx(className, 'container');
    return (React.createElement("span", { ref: ref, "data-qa": "CountDown", className: classNames, ...restProps }, value));
});
CountDown.defaultProps = {
    from: 0,
    speed: 500,
    interval: 100,
};
CountDown.displayName = 'CountDown';

export { CountDown };
//# sourceMappingURL=CountDown.js.map
